export interface ReportInput {
   key:string;
   required:boolean;
   defvalue?:any;
   label?:string;
   options?:{name:string, key:string}[];
}

const reportInputs:{[k:string]:ReportInput} = {
   EventIds: { key: 'eventIds', required: false },
   StartDate: { key: 'startDate', required: false },
   EndDate: { key: 'endDate', required: false },
   CampaignId: { key: 'campaignId', required: false },
   BrandId: { key: 'brandId', required: false },
   BrandIds: { key: 'brandIds', required: false },
   OrgId: { key: 'orgId', required: false },
   GuestTypeIds: { key: 'guestTypeIds', required: false },
   SurveyItems: { key: 'surveyItems', required: true, label: 'Survey Questions' },
   FcaBrand: {
      key: 'fcaBrand',
      required: true,
      label: 'NPS Brand',
      options: [
         { name: 'Alfa Romeo', key: 'alfa-romeo' },
         { name: 'Chrysler', key: 'chrysler' },
         { name: 'Dodge', key: 'dodge' },
         { name: 'Fiat', key: 'fiat' },
         { name: 'Jeep', key: 'jeep' },
         { name: 'RAM', key: 'ram' },
         { name: 'Generic', key: 'fca' }
      ]
   },
   NpsScope: {
      key: 'npsScope',
      required: true,
      defvalue: 'pre-post',
      label: 'NPS View',
      options: [
         { name: 'Ride and Drive', key: 'pre-post' },
         { name: 'Registration Only', key: 'pre' },
         { name: 'Any', key: 'any' }
      ]
   },
   FcaRegSource: {
      key: 'fcaRegSource',
      required: false,
      label: 'Registration Source',
      options: [
         { name: 'Online', key: 'Online' },
         { name: 'Paper', key: 'Paper' }
      ]
   },
   FcaConsumerType: {
      key: 'fcaConsumerType',
      required: false,
      label: 'Consumer Type',
      options: [
         { name: 'Conquest', key: 'Conquest' },
         { name: 'Loyalty', key: 'Loyalty' },
         { name: 'Any', key: 'any' }
      ]
   },
   DateRange: {
      key: 'dateRange',
      required: true,
      defvalue: '365',
      label: 'Date Range',
      options: [
         { name: '30 days', key: '30' },
         { name: '45 days', key: '45' },
         { name: '60 days', key: '60' },
         { name: '90 days', key: '90' },
         { name: '120 days', key: '120' },
         { name: '180 days', key: '180' },
         { name: '365 days', key: '365' }
      ]
   },
   Unique: {
      key: 'unique',
      required: false
   },
   Year: {
      key: 'year',
      required: true,
      defvalue: new Date().getFullYear().toString(),
      label: 'Select Year',
      options: [
         { name: 'Current Year', key: new Date().getFullYear().toString() },
         { name: 'Previous Year', key: (new Date().getFullYear() - 1).toString() }
      ]
   }
};

export default reportInputs;
